<template>
  <div>
    <h1>Still in progress... TBD</h1>
    <CCard>
      <CCardBody>
        <h3>User: {{ user.name }}</h3>

        Email: <strong>{{ user.email }}</strong
        ><br />
        Organization: <strong>{{ user.app_metadata.organization }}</strong>

        <pre>{{ user }}></pre>
      </CCardBody>
    </CCard>
    <CCard>
      <CCardBody>
        <h5>Roles</h5>
        <CDataTable
          :striped="true"
          :items="roles.data"
          hover
          :responsive="true"
        >
          <template #sources="{item}">
            <td class="py-2 text-left">
              <ul id="example-1">
                <li v-for="i in item.sources" :key="i.source_id">
                  {{ i.source_name }} ({{ i.source_type }})
                </li>
              </ul>
            </td>
          </template>
        </CDataTable>
      </CCardBody>
    </CCard>
    <CCard>
      <CCardBody>
        <h5>Permissions</h5>
        <CDataTable
          :striped="true"
          :items="permissions.data"
          hover
          :responsive="true"
        >
          <template #sources="{item}">
            <td class="py-2 text-left">
              <ul id="example-1">
                <li v-for="i in item.sources" :key="i.source_id">
                  {{ i.source_name }} ({{ i.source_type }})
                </li>
              </ul>
            </td>
          </template>
        </CDataTable>
      </CCardBody>
    </CCard>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import TheModal from "./../containers/TheModal";
import { Datetime } from "vue-datetime";
import "vue-datetime/dist/vue-datetime.css";
import moment from "moment";

export default {
  name: "EditUser",
  data() {
    return {
      user: {},
      permissions: {},
      roles: {},
      permissionsFields: [""],
    };
  },
  components: {
    TheModal,
    Datetime,
  },
  async mounted() {
    if (this.$route.params.user_id) {
      this.getUserDetails();
    } else {
      this.$router.go(-1);
    }
  },
  methods: {
    ...mapActions(["getUserAuth0", "getUserRole", "getUserPermissionsById"]),
    async getUserDetails() {
      let id = this.$route.params.user_id;
      this.user = await this.getUserAuth0(id);
      this.roles = await this.getUserRole(id);
      this.permissions = await this.getUserPermissionsById(id);
    },
  },
};
</script>

<style>
.pointer {
  cursor: pointer;
}

.bounce-enter-active {
  animation: bounce-in 0.15s;
}
.bounce-leave-active {
  animation: bounce-in 0.15s reverse;
}
@keyframes bounce-in {
  0% {
    transform: scale(0);
  }
  50% {
    transform: scale(1.5);
  }
  100% {
    transform: scale(1);
  }
}
</style>
